import { render, staticRenderFns } from "./milestone-plan-navigation-bar.vue?vue&type=template&id=20203b22&scoped=true&"
import script from "./milestone-plan-navigation-bar.vue?vue&type=script&lang=ts&"
export * from "./milestone-plan-navigation-bar.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-plan-navigation-bar.vue?vue&type=style&index=0&id=20203b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20203b22",
  null
  
)

export default component.exports